import { Grid } from '@material-ui/core'
import React from 'react'
import styled from 'styled-components'

import { CartFragment } from '../../../graphql/magento'
import { totalItemsDisplay, totalQuantityExcludingDependents } from '../../../lib/cart/item'
import { useDispensaryCartStatus } from '../../../lib/dispensaries/events/cart'
import { cartSubtotal } from '../../../utils/priceTools'

export interface CartHeadingProps {
  cart: CartFragment
  className?: string
}

const getMessageFromEventType = (
  type: ReturnType<typeof useDispensaryCartStatus>['startState']['type'],
): string => {
  switch (type) {
    case 'cart_initial':
      return 'Initializing your cart...'
    case 'cart_empty_start':
      return 'Preparing to add products...'
    case 'cart_add_products_start':
      return 'Adding products to the cart...'
    case 'cart_remove_promo_code_start':
      return 'Applying promotions...'
    case 'cart_apply_promo_code_start':
      return 'Applying promotions...'
    case 'cart_update_attributes_start':
      return 'Finalizing your cart...'
    case 'cart_final':
    default:
      return 'Your cart is ready.'
  }
}

const CartHeading: React.FC<CartHeadingProps> = ({ cart, className }) => {
  const {
    startState: { type },
    loading,
  } = useDispensaryCartStatus()

  return (
    <Grid
      alignItems="center"
      className={className}
      container
      item
      justify="space-between"
      xs={12}
      data-cy="cart-heading"
    >
      <Grid item>
        {loading ? (
          <strong className="robotoCondensed" data-cy={`cart-state-message-${type}`}>
            {getMessageFromEventType(type)}
          </strong>
        ) : (
          <>
            <strong className="robotoCondensed" data-cy="cart-state-message-cart_final">
              YOUR CART:{' '}
            </strong>
            {totalItemsDisplay(totalQuantityExcludingDependents(cart.items, cart.total_quantity))}
          </>
        )}
      </Grid>
      <Grid item>{loading ? '' : cartSubtotal(cart)}</Grid>
    </Grid>
  )
}

const StyledCartHeading = styled(CartHeading)`
  && {
    background-color: ${({ theme }) => theme.colors.coolGray.cool150};
    border-bottom: 1px solid ${({ theme }) => theme.colors.coolGray.cool250};
    border-top: 1px solid ${({ theme }) => theme.colors.coolGray.cool250};
    height: 55px;
    margin-top: 0;

    & .MuiGrid-item {
      padding-left: 15px;
      padding-right: 15px;
    }
  }

  @media (min-width: 600px) {
    && {
      border: 1px solid ${({ theme }) => theme.colors.coolGray.cool250};
    }
  }
`

export default StyledCartHeading
